/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function ManagedPrintServices() {
  return (
    <>
      {/* FEATURES SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            What’s Included
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            Professional print management designed to reduce waste, improve uptime,
            and optimize every device.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Device Monitoring
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Proactive monitoring of toner levels, errors, and device performance
                to prevent downtime.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Automated Supply Delivery
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Never run out of toner again — supplies are delivered automatically
                before you need them.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Maintenance & Repairs
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Full service support keeps your printers running without unexpected
                repair costs.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why Managed Print?"
        subtitle="Managed Print Services remove hidden costs and operational headaches from your printing environment."
        benefits={[
          {
            id: "lower-costs",
            title: "Lower Printing Costs",
            text: "Reduce waste, control monthly spending, and improve device efficiency.",
            delay: 0,
          },
          {
            id: "uptime",
            title: "Zero Device Downtime",
            text: "Proactive monitoring and routine maintenance keep printers available when you need them.",
            delay: 120,
          },
          {
            id: "productivity",
            title: "Improved Staff Productivity",
            text: "Your team focuses on work — not fixing printers or ordering supplies.",
            delay: 240,
          },
        ]}
        gainsTitle="What You’ll Gain"
        gains={[
          { id: "reduced-expenses", text: "Reduced print-related expenses" },
          { id: "predictable-billing", text: "Predictable monthly billing" },
          { id: "less-downtime", text: "Less downtime" },
          { id: "performance", text: "Optimized device performance" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Want predictable print management?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              Let us manage your printers with proactive service and full supply automation.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
